import { render, staticRenderFns } from "./OrderableCoupon.vue?vue&type=template&id=4d2a6524&"
import script from "./OrderableCoupon.vue?vue&type=script&lang=ts&"
export * from "./OrderableCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports